export const BLOG_IMAGES_KEY = "BLOG_IMAGES_KEY";
export const GALLERY_KEY = "GALLERY_IMAGES_KEY";
export const TAGS_KEY = "tags";
